import { DsStack } from '@am92/react-design-system'
import React from 'react'
import { Outlet } from 'react-router-dom'

export default function CleanLayout() {
  return (
    <DsStack
      sx={{
        padding: {
          xs: 'var(--ds-spacing-bitterCold)',
          lg: 'var(--ds-spacing-mild)'
        }
      }}
    >
      <Outlet />
    </DsStack>
  )
}
